<template>
    <div id="optionsFooter" class="options-footer" ref="optionsFooter"
        :class="[
            'options-footer',
            {'has-overlay': shouldShowOverlay},
            {'is-zoom-image': isZoomImage},
            {'full-height-footer': optionTileType === 3}
        ]">
        <transition name="footer-header-transition">
            <div class="footer-header" :class="{'has-categories': hasCategories}" v-show="shouldShowHeader">
                <span :class="'icon ' + icon"></span>
                <h3>{{ resource.heading }}</h3>
                <p v-if="!isTablet || optionTileType === 3">{{ resource.body }}</p>
            </div>
        </transition>

        <overlay
            :isDesktop="isDesktop"
            :shouldShow="shouldShowOverlay"
            @onClickClose="onClickOverlayClose">
            <image-layer wrapperClass="fragrance-image" :image="overlayResource.thumb" :shouldUpdateImage="true"></image-layer>
            <h1 v-if="shouldShowOverlay">{{ overlayResource.heading}}</h1>
            <p v-for="paragraph in overlayResource.body">{{ paragraph }}</p>

            <div v-for="note in overlayResource.notes" class="fragrance-note">
                <span class="fragrance-title">{{ note.Name }}</span>
                <span class="fragrance-text">{{ note.Description }}</span>
            </div>
        </overlay>

        <part-options
            :isTablet="isTablet"
            :isDesktop="isDesktop"
            @onClickPart="onClickPartOption"
            @onClickReadMore="onClickPartOptionReadMore">
        </part-options>

        <transition name="status-bar-transition">
            <status-bar :message="statusMessage" v-show="selectedPartUnavailable"></status-bar>
        </transition>

        <div class="button-row">
            <button class="btn btn--secondary" @click="cancel()">
                <span class="icon icon-close-thick"></span>
            </button>
            <button
                class="btn"
                :disabled=selectedPartUnavailable
                @click="accept()">
                <span class="icon icon-check"></span>
            </button>
        </div>
    </div>
</template>

<script src="./options-footer.js"></script>
